import { receive, mutate, dispatch } from "./api.service";

export const getAllEvents = () => receive(`/events`);
export const getEventById = (id) => receive(`/event/${id}`);
export const getEventBySlug = (slug) => receive(`/event/slug/${slug}`);

export const getFilteredEvents = (search) => receive(`/events?title=${search}`);

export const uploadFile = (data) => dispatch(data, "/file/upload");

export const getAllNews = () => receive(`/news`);
export const getFilteredNews = (search) => receive(`/news?title=${search}`);
export const getNewsBySlug = (slug) => receive(`/news/slug/${slug}`);
export const updateNewsViews = (data, id) =>
  mutate(data, `/news/update-view/${id}`);

export const getAllResources = (query) => receive(`/resources${query}`);
export const getCategoryResources = (category) =>
  receive(`/resources?category=${category}`);

export const getResourceById = (id) => receive(`/resource/${id}`);
export const getResourceBySlug = (slug) => receive(`/resource/slug/${slug}`);
